export default "__VITE_ASSET__CgjcMRhk__"